// extracted by mini-css-extract-plugin
export default {"lightBlurPreloader":"Spinner_lightBlurPreloader__Xc2My","spinnerSize":"Spinner_spinnerSize__n-eqA","paginationSpinnerSize":"Spinner_paginationSpinnerSize__zF11B"};